import * as iamCallback from "./iamCallback";
import * as mainBody from "./mainBody";
import * as mediaSocial from "./mediaSocial";
import * as numStepFacadeImpl from "./numStepFacadeImpl";
import * as organization from "./organization";
import * as organizationFacadeImpl from "./organizationFacadeImpl";
import * as organizationLevel from "./organizationLevel";
import * as organizationPost from "./organizationPost";
import * as organizationPostRelation from "./organizationPostRelation";
import * as organizationRank from "./organizationRank";
import * as organizationStaff from "./organizationStaff";
import * as organizationStaffFacadeImpl from "./organizationStaffFacadeImpl";
import * as sysMenu from "./sysMenu";
import * as sysMenuResource from "./sysMenuResource";
import * as sysNumStep from "./sysNumStep";
import * as sysProperties from "./sysProperties";
import * as sysRole from "./sysRole";
import * as sysRoleData from "./sysRoleData";
import * as sysRoleMenu from "./sysRoleMenu";
import * as sysRoleResource from "./sysRoleResource";
import * as sysUser from "./sysUser";
import * as sysUserData from "./sysUserData";
import * as sysUserLogin from "./sysUserLogin";
import * as sysUserLoginLog from "./sysUserLoginLog";
import * as sysUserRole from "./sysUserRole";
import * as sysUserTableau from "./sysUserTableau";
import * as sysUserToken from "./sysUserToken";
import * as userFacadeImpl from "./userFacadeImpl";
import * as userListFacadeImpl from "./userListFacadeImpl";
import * as wechatOpen from "./wechatOpen";

export const ucenter = {
  iamCallback,
  mainBody,
  mediaSocial,
  numStepFacadeImpl,
  organization,
  organizationFacadeImpl,
  organizationLevel,
  organizationPost,
  organizationPostRelation,
  organizationRank,
  organizationStaff,
  organizationStaffFacadeImpl,
  sysMenu,
  sysMenuResource,
  sysNumStep,
  sysProperties,
  sysRole,
  sysRoleData,
  sysRoleMenu,
  sysRoleResource,
  sysUser,
  sysUserData,
  sysUserLogin,
  sysUserLoginLog,
  sysUserRole,
  sysUserTableau,
  sysUserToken,
  userFacadeImpl,
  userListFacadeImpl,
  wechatOpen,
};
